import { useMemo } from "react";

/**
 * Derives tab completion flags without effect-driven state (fewer renders).
 */
export function useCallLogDialogValidations({
  formData,
  selectedProducts,
  selectedKeyMessagesByProduct,
}) {
  return useMemo(() => {
    const baseValid =
      formData.salesRepName && formData.territoryName && formData.callDateTime;

    const normalValid = baseValid && formData.accountName;

    const groupValid =
      baseValid &&
      Boolean(
        formData.institutionId && String(formData.institutionId).trim(),
      ) &&
      (formData.attendees || []).length > 0;

    const professionalInfo = !!(
      formData.callType === "group" ? groupValid : normalValid
    );

    const products = selectedProducts || [];
    const hasProducts = products.length > 0;
    const detailingPriority = !!(
      hasProducts &&
      products.every(
        (p) => (selectedKeyMessagesByProduct?.[p] || []).length > 0,
      )
    );

    return { professionalInfo, detailingPriority };
  }, [formData, selectedProducts, selectedKeyMessagesByProduct]);
}
